import { Immutable } from "immer";
import React from "react";

import { templates } from "@reactivated";

import { ProductPageBody } from "../productModulesBody";

/**
 * tempurpedic ProductDisplayPage ``modules`` body assembly (#33589).
 *
 * The legacy ``product_display_page.html`` rendered the body as a bare
 * ``{% for block in self.modules %}{% include_block block %}{% endfor %}`` loop
 * inside ``<div class="pdp-blocks">`` (NO per-block Wagtail wrapper), so this
 * consolidates into a single ``include_react`` root rendered with
 * ``tagName={React.Fragment}`` (``wrapBlocks`` unset). The ``.pdp-blocks`` div
 * and the hero chrome above it stay in the page template.
 *
 * ``use_default_design`` drives the alt-design filter: on the ALTERNATIVE design
 * the page's hero extracts the top-level ``gallery_block`` /
 * ``value_prop_bar_block`` (the template's own ``{% for ... include_block %}``
 * loops, kept in Django), so the shared assembly drops those two top-level block
 * types to avoid double-rendering. See ``productModulesBody.tsx`` ``IProps``.
 */
type IProps = Immutable<
    Pick<
        templates.ProductDisplayPageTemplate,
        | "page"
        | "use_default_design"
        | "hardcoded_ssr"
        | "hotspot_ssr"
        | "breadcrumbs_ssr"
        | "customer_service_ssr"
        | "shop_compare_ssr"
        | "tab_feature_attribute_ssr"
        | "reviews_ssr"
        | "reviews"
        | "page_num_reviews"
        | "change_variant_ssr"
        | "change_root_ssr"
        | "root_conditional_ssr"
        | "variant_conditional_ssr"
        | "tab_cards_initial_root_product_id"
    >
>;

export const ProductDisplayPageBody = (
    props: IProps,
): React.JSX.Element | null => {
    // ``modules`` is nullable (``null=True, blank=True``); render nothing when
    // null/empty.
    if (!props.page.modules) {
        return null;
    }
    return (
        <ProductPageBody
            value={props.page.modules.value}
            useDefaultDesign={props.use_default_design}
            hardcoded_ssr={props.hardcoded_ssr}
            hotspot_ssr={props.hotspot_ssr}
            breadcrumbs_ssr={props.breadcrumbs_ssr}
            customer_service_ssr={props.customer_service_ssr}
            shop_compare_ssr={props.shop_compare_ssr}
            tab_feature_attribute_ssr={props.tab_feature_attribute_ssr}
            reviews_ssr={props.reviews_ssr}
            reviews={props.reviews}
            pageNumReviews={props.page_num_reviews}
            changeVariantSSR={props.change_variant_ssr}
            changeRootSSR={props.change_root_ssr}
            rootConditionalSSR={props.root_conditional_ssr}
            variantConditionalSSR={props.variant_conditional_ssr}
            tabCardsInitialRootProductID={
                props.tab_cards_initial_root_product_id
            }
        />
    );
};
